import { NormalizedTeamMembersAllocations } from './types';

const getMemoByClientAndAllocation = (
  allocations: NormalizedTeamMembersAllocations[],
  clientId: number,
  allocationId: number,
  teamMemberId: number,
): string => {
  const member = allocations.find(alloc => alloc.id === teamMemberId);
  if (!member) return '';
  const allClients = [...member.clientsAllocations, ...member.crisisAllocations];
  return (
    allClients.find(c => c.clientId === clientId && c.allocation?.id === allocationId)?.memo ?? ''
  );
};

export default getMemoByClientAndAllocation;
